module.exports = __webpack_public_path__ + "img/call-bold-20x20.cd7b4d1c.svg";